// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConnectedBreadcrumb_wrapper__HmrgU","overflow":"ConnectedBreadcrumb_overflow__AMstb"};